import { showLoader, stopLoader } from "../redux/slices/generalSlice";
import {
  setRole,
  setOrderType,
  setUserBrand,
  setUserBrandId,
} from "../redux/slices/userSlice";
import Api, { AuthApi } from ".";
import ApiEndPoint from "./ApiEndpoint";
import { deleteAllCookies, setCookie, forceLogout } from "../helpers/general";
export const sendOtp = (email) => async (dispatch) => {
  try {
    dispatch(showLoader());
    const url =
      ApiEndPoint.otp + ApiEndPoint.email + ApiEndPoint.send + ApiEndPoint.v1;
    const userObject = {
      email,
    };
    const { data } = await AuthApi.post(url, userObject);
    dispatch(stopLoader());
    return data;
  } catch (e) {
    const res = e.response;
    dispatch(stopLoader());
    return res;
  }
};

export const verifyOtp =
  (otpData, successMethod = () => null, errorMethod = () => null) =>
  async (dispatch) => {
    try {
      dispatch(showLoader());
      const url =
        ApiEndPoint.otp +
        ApiEndPoint.email +
        ApiEndPoint.verify +
        ApiEndPoint.v1;
      const body = { ...otpData };
      const {
        data: { data },
      } = await AuthApi.post(url, body);
      setCookie("userAuth", "true", 1);
      // dispatch(setRole(data?.roles));
      // dispatch(setOrderType(data?.orderTypes));
      // dispatch(setUserBrand(data?.brand));
      // dispatch(setUserBrandId(data?.brandId));
      successMethod();
      dispatch(stopLoader());
      return data;
    } catch (e) {
      const error = e.response;
      dispatch(stopLoader());
      errorMethod(
        error?.data?.data?.errorMessage ??
          "Something went wrong. Please try again..!"
      );
      return error;
    }
  };

export const logout =
  (successMethod = () => null) =>
  async (dispatch) => {
    try {
      dispatch(showLoader());
      const url = ApiEndPoint.auth + ApiEndPoint.user + ApiEndPoint.logout;
      const { data } = await Api.post(url);
      setCookie("userAuth", "false", -1);
      deleteAllCookies();
      try {
        localStorage.clear();
        sessionStorage.clear();
      } catch (err) {
        console.warn("localStorage unavailable", err);
      }
      forceLogout();
      successMethod();
      dispatch(stopLoader());
      return data;
    } catch (e) {
      dispatch(stopLoader());
      return e?.response;
    }
  };

// eslint-disable-next-line
export default { sendOtp, verifyOtp, logout };
